<div class="footer-content">
  <span>Last update: 2 February 2026</span>
  <span>© 2026 Chevron Corporation</span>
  <span>Company Confidential</span>
</div>
<div class="footer-contacts">
  <span>Content contact: <a href="#">WTV</a></span>
  <span>Technical contact: <a href="#">WTV</a></span>
</div>
